import React from 'react'
import Chart from './Chart'

export default function Skills() {
  return (
    <>
    <section class="skill-section" id="skills">
     <h1 className='skills-head' >My Skills</h1>
          <div class="skill--grid-container">
         <i class="fa-brands fa-html5 fa-5x html-icon"></i>
         <i class="fa-brands fa-css3-alt fa-5x css-icon"></i>
         <i class="fa-brands fa-js fa-5x js-icon"></i>
          <i class="fa-brands fa-bootstrap fa-5x bootstrap-icon"></i>
          <i class="fa-brands fa-react fa-5x react-icon"></i>
         <i class="fa-brands fa-python fa-5x python-icon"></i>
         <i class="fa-brands fa-git-alt fa-5x git-icon"></i>
         <i class="fa-brands fa-github fa-5x github-icon"></i>
        </div>
        </section>
        <h1 className='chart-head' >Days I Code</h1>
        <Chart/>
      
      </>
  )
  }